import { performanceEntries } from "../performanceEntries";
import { entries } from "../entries";

interface Metrics {
    size?: number;
    duration?: number;
    count?: number;
}

const add = (
    metrics: Metrics,
    type: string,
    { duration = 0, transferSize: size = 0, count = 1 }: PerformanceEntry,
): Metrics =>
    entries({
        size,
        duration,
        count,
    }).reduce(
        (
            metrics,
            [key, value],
        ): {
            size: number;
            duration: number;
            count: number;
        }[] => {
            metrics[key] = metrics[key] || 0;
            metrics[key] += value;
            return metrics;
        },
        (metrics[type] = metrics[type] || {}),
    );

export function cumulativeResourceMetricsMark(): Partial<PerformanceMark>[] {
    const metrics: Metrics = {};
    const map = new Map<string, string | null>([
        ["link", "asset"],
        ["script", "asset"],
        ["img", "image"],
        ["video", "video"],
        ["fetch", "ajax"],
        ["xmlhttprequest", "ajax"],
        ["other", null],
        ["beacon", null],
    ]);
    performanceEntries({ type: "resource" }).forEach((resource) => {
        const type = map.get(resource.initiatorType);
        type && add(metrics, type, resource);
        add(metrics, "all", resource);
    });
    const entry: Partial<PerformanceMark> = {
        name: "cumulative_resource_metrics",
        entryType: "mark",
        metrics: entries(metrics).map(([type, values]) => ({
            type,
            ...(values as any),
        })),
        _mergeable: true,
    };
    return [entry];
}
